export default theme => ({
    profileEditorContainer: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 4,
        padding: `0px ${theme.spacing.unit * 2}px ${theme.spacing.unit * 2}px`,
        [theme.breakpoints.up('sm')]: {
            marginLeft: 'auto',
            marginRight: 'auto',
        },

        '& .submitButton': {
            marginTop: 30,
        },

        '& .editionContainer': {
            display: 'flex',
            justifyContent: 'flex-end',
            fontSize: '.9em',
        },
    },
});
